import './index.css'
import clsx from 'clsx'
import React from 'react'
type Props = {
  currencySymbol: React.ReactNode
  price: React.ReactNode
  period: React.ReactNode
  className?: string
}

const Price = (props: Props): React.ReactNode => {
  const { currencySymbol, price, period, className } = props
  return (
    <div className={clsx('Price', className)}>
      <div
        className={clsx('Price_Num', {
          'Price_Num--Disable': price === 0,
        })}
      >
        {currencySymbol}
        {price}
        {period && <span className="Price_Period">{period}</span>}
      </div>
    </div>
  )
}

Price.defaultProps = {
  currencySymbol: '$',
  className: '',
}
export default Price
